exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.st0 {\n    fill: #4B4B4B;\n}\n", ""]);

// exports
